<template>
  <div class="mx-3">
    <div>
      <el-table
        ref="multipleTable"
        :data="reportList"
        :empty-text="$t('no_data')"
        stripe
        style="width: 100%"
        header-row-class-name="thead-dark"
        size="small"
      >
        <el-table-column prop="report_name" :label="$t('project.report_name')">
          <template v-slot="scope">
            {{ scope.row.name }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="brainage"
          :label="$t('analyse.brainage')"
          width="80"
        >
          <template v-slot="scope">{{ scope.row.brainage || "" }} </template>
        </el-table-column> -->

        <el-table-column
          prop="date_create"
          :label="$t('project.c_time')"
          width="180"
        >
          <template v-slot="scope">
            {{ scope.row.date_create }}
          </template>
        </el-table-column>

        <el-table-column prop="status" :label="$t('operate')">
          <template v-slot="scope">
            <span v-if="scope.row.template < 100">
              <a
                :href="scope.row.report_url"
                target="_blank"
                class="mr-3 text-success"
                v-if="scope.row.status == 4 || scope.row.status > 5"
              >
                <i class="fa fa-file"></i> 查看</a
              >

              <a
                class="mr-3 text-success"
                v-if="scope.row.status == 6"
                @click="downloadpdf(scope.row)"
                ><i class="fa fa-file-pdf"></i> 下载PDF</a
              >

              <el-popconfirm
                :title="$t('notice.p_confirm')"
                :confirm-button-text="$t('confirm')"
                :cancel-button-text="$t('cancel')"
                @confirm="removelink(scope.row)"
              >
                <a class="mr-3 text-muted" slot="reference">
                  <i class="fa fa-trash"></i> 删除
                </a>
              </el-popconfirm>

              <a class="mr-3 text-muted" v-if="scope.row.status == 2"
                >等待生成报告</a
              >
              <a class="mr-3 text-muted" v-else-if="scope.row.status == 3"
                >正在生成报告</a
              >
              <a class="mr-3 text-muted" v-else-if="scope.row.status == 5"
                >创建失败,请先删除,再重新创建</a
              >
              <a class="mr-3 text-muted" v-else-if="scope.row.status == 4"
                >等待生成PDF</a
              >

              <a class="mr-3 text-muted" v-else-if="scope.row.status == 8">
                正在生成PDF</a
              >
              <a class="mr-3 text-danger" v-else-if="scope.row.status == 7">
                PDF生成失败</a
              >
            </span>
            <span v-else-if="scope.row.template == 100">
              <a
                :href="scope.row.report_url"
                target="_blank"
                class="mr-3 text-success"
              >
                <i class="fa fa-file"></i> 查看
              </a>

              <a @click="downloadpdf(r)" class="mr-3 text-success"
                ><i class="fa fa-file-pdf"></i> 下载
              </a>
            </span>
            <span v-else>
              <a
                :href="scope.row.report_url"
                target="_blank"
                class="mr-3 text-success"
              >
                <i class="fa fa-file"></i> 查看
              </a>

              <a @click="downloadImages(r)" class="mr-3 text-success"
                ><i class="fa fa-file-pdf"></i> 下载
              </a>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="my-3 py-3 text-right">
      <button
        type="button"
        v-if="reportList.length > 0"
        class="btn btn-warning btn-sm mx-3"
      >
        <i class="fa fa-brain"></i>
        {{ $t("analyse.brainage_edit") }}
      </button>

      <button
        type="button"
        class="btn btn-warning btn-sm mr-3"
        v-if="reportList.length > 0"
      >
        <i class="fa fa-upload"></i> 上传电子胶片
      </button>
      <button
        type="button"
        class="btn btn-warning btn-sm"
        v-if="reportList.length > 0"
      >
        <i class="fa fa-upload"></i> 上传放射科报告
      </button>
    </div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getReportList, removeReport } from "../../api/api";
import { Loading } from "element-ui";

export default {
  components: {},
  props: {
    subject_id: {
      type: String,
      default: "",
    },
    task_id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      reportTemplates: [
        {
          template: 1,
          name: "脑结构分析报告",
        },
        {
          template: 2,
          name: "脑结构分析报告 II",
        },
        {
          template: 3,
          name: "脑龄评估报告",
        },
        {
          template: 4,
          name: "脑健康评估报告",
        },
        {
          template: 5,
          name: "脑健康评估报告 II",
        },
        {
          template: 10,
          name: "脑健康评估报告 III",
        },
        {
          template: 6,
          name: "全脑结构评估报告",
        },
        {
          template: 7,
          name: "大脑 - 脏腑评估报告",
        },
        {
          template: 8,
          name: "大脑 - 中医情志评估报告",
        },
        {
          template: 9,
          name: "大脑 - 经络评估报告",
        },
      ],
      reportList: [],
      total: 0,
    };
  },

  computed: {
    ...mapState({
      lang: (state) => state.language,
      url_backendapi: (state) => state.url_backendapi, //:28801
      url_adaptorapi: (state) => state.url_adaptorapi, //:28000
    }),
  },
  filters: {},
  watch: {},
  methods: {
    async downloadpdf(r) {
      const me = this;

      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });
      // const postdata = {
      //   reportid: r.id,
      //   taskid: r.tid,
      // };
      const pdfurl =
        me.url_backendapi + "/ossfs/report/" + r.tid + "/" + r.id + ".pdf";
      const pdfname = r.name;
      try {
        fetch(pdfurl)
          .then((r) => r.blob())
          .then((blob) => {
            var newBlob = new Blob([blob], {
              type: "application/pdf",
            });

            //var filename = "Report-" + new Date().getTime() + ".pdf";
            if (typeof window.navigator.msSaveBlob !== "undefined") {
              window.navigator.msSaveBlob(newBlob, pdfname);
              return;
            }

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(newBlob);
              return;
            }

            //console.log(pdfname)
            const data = window.URL.createObjectURL(newBlob);
            var link = document.createElement("a");
            link.href = data;
            link.download = pdfname;
            link.click();
            setTimeout(function () {
              window.URL.revokeObjectURL(data);
            }, 100);
          });
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    async fetchReport() {
      const me = this;

      const postdata = {
        task_id: me.task_id,
      };

      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      try {
        let res = await getReportList(postdata);
        if (res.status === 200) {
          me.reportList = res.result;
          me.total = res.total;
        }
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    async removelink(r) {
      const me = this;

      const postdata = {
        reportid: r.id,
        tid: me.task_id,
      };

      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      try {
        let res = await removeReport(postdata);
        if (res.status === 200) {
          me.reportList.forEach((item, index) => {
            if (item.id == r.id) {
              me.reportList.splice(index, 1);
            }
          });
          me.$message({
            message: "删除成功",
            type: "success",
          });
        }
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
  },
  mounted() {
    this.fetchReport();
  },
};
</script>
<style lang="less" scoped>
.data-content {
  padding: 20px;
  .report_template {
    width: 240px;
  }
}
</style>